var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import { createUIElement, SPACING_M, SPACING_S } from "../helpers";
import { DatetimeInputContext } from "../controls/DatetimeInput/DatetimeInputContext";
import { MonthSelector } from './MonthSelector';
import { Month } from './Month';
import { useMonthCalendarViewModel } from './hooks';
import { Button, BUTTON_VIEW } from "../Button";
import { Icon } from "../Icon";
import { TodaySvg } from "../controls/DatetimeInput/icons";
import { DEFAULT_TEXTS, dataSelectorId } from './helpers';
var StyledMonth = styled(Month)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    padding-left: ", ";\n    padding-right: ", ";\n"], ["\n    padding-left: ", ";\n    padding-right: ", ";\n"])), SPACING_S, SPACING_S);
var MonthFooter = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: row;\n    margin-top: ", ";\n"], ["\n    display: flex;\n    flex-direction: row;\n    margin-top: ", ";\n"])), SPACING_M);
var MonthContainer = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: stretch;\n"], ["\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-start;\n    align-items: stretch;\n"])));
var Root = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: inline-flex;\n    flex-direction: column;\n"], ["\n    display: inline-flex;\n    flex-direction: column;\n"])));
var getMonthSelectorText = function (_a, texts) {
    var year = _a.year, month = _a.month;
    var MONTHS = {
        0: texts.january,
        1: texts.february,
        2: texts.march,
        3: texts.april,
        4: texts.may,
        5: texts.june,
        6: texts.july,
        7: texts.august,
        8: texts.september,
        9: texts.october,
        10: texts.november,
        11: texts.december
    };
    return MONTHS[month] + " " + year;
};
export var MonthCalendar = createUIElement('MonthCalendar', function (_a, ref) {
    var className = _a.className, initialShownMonth = _a.initialShownMonth, _b = _a.startDatetime, startDatetime = _b === void 0 ? new Date(0) : _b, _c = _a.endDatetime, endDatetime = _c === void 0 ? new Date(9999, 11, 31) : _c, isDisabledDate = _a.isDisabledDate, _d = _a.showCurrentDate, showCurrentDate = _d === void 0 ? true : _d, selectedDate = _a.selectedDate, _e = _a.hasToday, hasToday = _e === void 0 ? true : _e, _f = _a.hasMonthSelector, hasMonthSelector = _f === void 0 ? true : _f, onSelect = _a.onSelect, _g = _a.highlightDates, highlightDates = _g === void 0 ? [] : _g, texts = _a.texts, onMonthClick = _a.onMonthClick, onMonthChange = _a.onMonthChange, onClick = _a.onClick, onMouseDown = _a.onMouseDown, onMouseUp = _a.onMouseUp, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onKeyDown = _a.onKeyDown, onKeyUp = _a.onKeyUp, onKeyPress = _a.onKeyPress, style = _a.style, rest = __rest(_a, ["className", "initialShownMonth", "startDatetime", "endDatetime", "isDisabledDate", "showCurrentDate", "selectedDate", "hasToday", "hasMonthSelector", "onSelect", "highlightDates", "texts", "onMonthClick", "onMonthChange", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    var uiTexts = __assign(__assign({}, DEFAULT_TEXTS), texts);
    var now = useContext(DatetimeInputContext).getNowTime();
    var _h = useMonthCalendarViewModel({
        selectedDate: selectedDate,
        initialShownMonth: initialShownMonth,
        startDatetime: startDatetime,
        endDatetime: endDatetime,
        onSelect: onSelect,
        isDisabledDate: isDisabledDate,
        onMonthChange: onMonthChange
    }), selectedDateFromViewModel = _h.selectedDate, shownMonth = _h.shownMonth, isDayDisabled = _h.isDayDisabled, hasPrevMonth = _h.hasPrevMonth, hasNextMonth = _h.hasNextMonth, onPrevMonthClick = _h.onPrevMonthClick, onNextMonthClick = _h.onNextMonthClick, onTodaySelect = _h.onTodaySelect;
    return (React.createElement(Root, __assign({}, rest, { "data-selector-id": rest['data-selector-id'], className: "vm-MonthCalendar " + className, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }),
        hasMonthSelector && (React.createElement(MonthSelector, { text: getMonthSelectorText(shownMonth, uiTexts), hasPrev: hasPrevMonth, hasNext: hasNextMonth, onPrevClick: onPrevMonthClick, onNextClick: onNextMonthClick, onSelectClick: onMonthClick })),
        React.createElement(MonthContainer, null,
            React.createElement(StyledMonth, { texts: {
                    shortSunday: uiTexts.shortSunday,
                    shortMonday: uiTexts.shortMonday,
                    shortTuesday: uiTexts.shortTuesday,
                    shortWednesday: uiTexts.shortWednesday,
                    shortThursday: uiTexts.shortThursday,
                    shortFriday: uiTexts.shortFriday,
                    shortSaturday: uiTexts.shortSaturday
                }, year: shownMonth.year, month: shownMonth.month, value: selectedDateFromViewModel, onSelect: onSelect, hasStaticNumberOfWeek: true, isDayDisabled: isDayDisabled, highlightDates: highlightDates, showCurrentDate: showCurrentDate }),
            hasToday && (React.createElement(MonthFooter, null,
                React.createElement(Button, { "data-selector-id": dataSelectorId.todayControl, disabled: isDayDisabled(now), onClick: onTodaySelect, ui: BUTTON_VIEW.text },
                    React.createElement(Icon, { src: React.createElement(TodaySvg, null) }),
                    uiTexts.today))))));
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=MonthCalendar.js.map